// extracted by mini-css-extract-plugin
export default {"imageContainer":"A1-z","summaryPar":"B1-z","ratingCategories":"C1-z","reviewerInfo":"D1-z","reviewTypes":"E1-z","expanded":"F1-z"};